import { FilterValue } from './FilterableTable';

export function numberOperatorMatch(value?: number, filter?: FilterValue<number>) {
  if (!filter || value === undefined) return true;
  const op = filter.operator ?? '=';
  switch (op) {
    case '>':
      return value > filter.value;
    case '>=':
      return value >= filter.value;
    case '<':
      return value < filter.value;
    case '<=':
      return value <= filter.value;
    case 'not':
      return value != filter.value;
    default: // case '=':
      return value == filter.value;
  }
}
